import axios from '../config/axiosConfig';
import apiKey from './constant/ApiKey';
import { ADMIN_URL } from './constant/BaseApiUrl';

export default class CurrencyService {
  getCurrency() {
    return axios.get(`${ADMIN_URL}${apiKey.GET_CURRENCY}`);
  }

  updateCurrency(payload) {
    return axios.put(`${ADMIN_URL}${apiKey.GET_CURRENCY}`, payload);
  }
}
